import * as React from 'react';
import { AlertType, ISingleAlert } from '../alert-type';
import { AlertPopup } from '../types/alert/alert';
import { ConfirmPopup } from '../types/confirm';

interface IProps {
  // alerts host can work with various kind of popups, therefore let generic be typed as 'any' here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  alertsPopupsList: ISingleAlert<any>[];
  closePopup: () => void;
}

const AlertPopupsContainer: React.FC<IProps> = ({ alertsPopupsList, closePopup }) => {
  const registeredAlertTypes = {
    [AlertType.alert]: AlertPopup,
    [AlertType.confirm]: ConfirmPopup
};
  return alertsPopupsList?.length
    ? (
      <>
        {
          alertsPopupsList.map((popupState, index) => {
              const PopupComponent = registeredAlertTypes[popupState.type];
              return <PopupComponent
                  key={index}
                  closeHandler={closePopup}
                  popupProps={popupState.popupProps}
              />;
          })
        }
      </>
    )
    : null;
};

export { AlertPopupsContainer };
